import LiteAuth from 'Components/Guards/LiteAuth';

export default {
    'lite-auth': LiteAuth,
};